import { sample } from "lodash";

export const firstNames = [
  "John",
  "Bob",
  "Charlie",
  "David",
  "Frank",
  "Hank",
  "Ivy",
  "Jack",
  "Alice",
  "Eve",
  "Grace",
  "Heidi",
  "Judy",
  "Mallory",
  "Niaj",
  "Olivia",
  "Peggy",
  "Sybil",
  "Trent",
  "Bruce",
  "Walter",
  "Xander",
  "Yvonne",
  "Zara",
  "Aaron",
  "Beth",
  "Cathy",
  "Derek",
  "Ethan",
  "Fiona",
  "George",
  "Hannah",
  "Ian",
  "Julia",
  "Kevin",
  "Laura",
  "Mike",
  "Nina",
  "Oscar",
  "Paula",
  "Quincy",
  "Rachel",
  "Steve",
  "Tina",
  "Uma",
  "Vince",
  "Wendy",
  "Xena",
  "Yara",
  "Zane",
]

export const middleNames = [
  "Mark",
  "Morgan",
  "Oliver",
  "Paul",
  "Quentin",
  "Ralph",
  "Sam",
  "Thomas",
  "Ulysses",
  "Victor",
  "William",
  "Xavier",
  "Yosef",
  "Zachary",
  "Adam",
  "Brian",
  "Carl",
  "Dylan",
  "Edward",
  "Franklin",
  "Gordon",
  "Henry",
  "Isaac",
  "James",
  "Kyle",
  "Leon",
  "Martin",
  "Nathan",
  "Owen",
  "Peter",
  "Quinn",
  "Roger",
  "Scott",
  "Timothy",
  "Umar",
  "Vincent",
  "Wayne",
  "Yuri",
  "Arthur",
  "Blake",
  "Cameron",
  "Dean",
  "Elliot",
  "Felix",
  "Graham",
  "Howard",
  "Jasper",
  "Keith",
  "Liam",
  "Miles",
  "Noah",
  "Simon",
]

export const lastNames = [
  "Smith",
  "Johnson",
  "Williams",
  "Jones",
  "Brown",
  "Davis",
  "Miller",
  "Wilson",
  "Moore",
  "Taylor",
  "Anderson",
  "Thomas",
  "Jackson",
  "White",
  "Harris",
  "Martin",
  "Thompson",
  "Garcia",
  "Martinez",
  "Robinson",
  "Clark",
  "Rodriguez",
  "Lewis",
  "Lee",
  "Walker",
  "Hall",
  "Allen",
  "Young",
  "Hernandez",
  "King",
  "Wright",
  "Lopez",
  "Hill",
  "Scott",
  "Green",
  "Adams",
  "Baker",
  "Gonzalez",
  "Nelson",
  "Carter",
  "Mitchell",
  "Perez",
  "Roberts",
  "Turner",
  "Phillips",
  "Campbell",
  "Parker",
  "Evans",
  "Edwards",
  "Collins",
]

export function getRandomName() {
  const firstName = sample(firstNames);
  const lastName = sample(lastNames);
  let middleName;
  do {
    middleName = sample(middleNames);
  } while (middleName === firstName);
  return { firstName, middleName, lastName };
}
